import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';
import { Role } from './useValidateSession';

export interface InviteUserInput {
    email: string;
    position: Role;
    locationId: Array<string> | 'all';
}

export const useInviteUser = () => {
    const sessionContext = useContext(SessionContext);

    const inviteUser = async (input: InviteUserInput) => {
        return axios.post(`${API_URL}/settings/user/invite`, input, {
            headers: {
                Authorization: sessionContext?.sessionId ?? ''
            }
        });
    };

    return useMutation({
        mutationFn: inviteUser,
    });
};